export enum EventName {
    THREEDS = 'THREEDS'
}